/* --- QUESTIONNAIRE CONFIG --- */

export interface QuestionnairePsqi {
  position: number;
  question: string;
  answers: string[];
}

export const Q_PSQI: QuestionnairePsqi[] = [
  {
    position: 1, question: 'Nell\'ultimo mese, di solito, a che ora è andata/o a letto la sera?' ,
    answers: [null]
  },
  {
    position: 2, question: 'Nell\'ultimo mese, di solito, quanto tempo (in minuti) ha impiegato ad addormentarsi?' ,
    answers: [null]
  },
  {
    position: 3, question: 'Nell\'ultimo mese, di solito, a che ora si è alzato/o a al mattino?' ,
    answers: [null]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 4, question: 'Nell\'ultimo mese, quante ore ha dormito effettivamente per notte? (potrebbero essere diverse dal numero di ore passate a letto)' ,
    answers: [null]
  },
  {
    position: 5, question: 'a) non riuscire ad addormentarsi entro 30 minuti',
    answers: [
      'Non durante l\'ultimo mese',
      'Meno di una volta a settimana',
      'Una o due volte a settimana',
      'Tre o più volte a settimana'
    ]
  },
  {
    position: 6, question: 'b) svegliarsi nel mezzo della notte o al mattino presto senza riaddormentarsi',
    answers: [
      'Non durante l\'ultimo mese',
      'Meno di una volta a settimana',
      'Una o due volte a settimana',
      'Tre o più volte a settimana'
    ]
  },
  {
    position: 7, question: 'c) alzarsi nel mezzo della notte per andare in bagno',
    answers: [
      'Non durante l\'ultimo mese',
      'Meno di una volta a settimana',
      'Una o due volte a settimana',
      'Tre o più volte a settimana'
    ]
  },
  {
    position: 8, question: 'd) non riuscire a respirare bene',
    answers: [
      'Non durante l\'ultimo mese',
      'Meno di una volta a settimana',
      'Una o due volte a settimana',
      'Tre o più volte a settimana'
    ]
  },
  {
    position: 9, question: 'e) tossire o russare forte',
    answers: [
      'Non durante l\'ultimo mese',
      'Meno di una volta a settimana',
      'Una o due volte a settimana',
      'Tre o più volte a settimana'
    ]
  },
  {
    position: 10, question: 'f) sentire troppo freddo',
    answers: [
      'Non durante l\'ultimo mese',
      'Meno di una volta a settimana',
      'Una o due volte a settimana',
      'Tre o più volte a settimana'
    ]
  },
  {
    position: 11, question: 'g) sentire troppo caldo',
    answers: [
      'Non durante l\'ultimo mese',
      'Meno di una volta a settimana',
      'Una o due volte a settimana',
      'Tre o più volte a settimana'
    ]
  },
  {
    position: 12, question: 'h) fare brutti sogni',
    answers: [
      'Non durante l\'ultimo mese',
      'Meno di una volta a settimana',
      'Una o due volte a settimana',
      'Tre o più volte a settimana'
    ]
  },
  {
    position: 13, question: 'i) avere dolori',
    answers: [
      'Non durante l\'ultimo mese',
      'Meno di una volta a settimana',
      'Una o due volte a settimana',
      'Tre o più volte a settimana'
    ]
  },
  {
    position: 14, question: 'j) C\'è qualche altro problema che può aver disturbato il suo sonno?',
    answers: [
      'No',
      'Si (specificare)'
    ]
  },
  {
    position: 15, question: 'E quanto spesso ha avuto problemi a dormire per questo motivo?',
    answers: [
      'Non durante l\'ultimo mese',
      'Meno di una volta a settimana',
      'Una o due volte a settimana',
      'Tre o più volte a settimana'
    ]
  },
  {
    position: 16, question: 'Nell\'ultimo mese, come valuta complessivamente la qualità del suo sonno?',
    answers: [
      'Molto buona',
      'Abbastanza buona',
      'Abbastanza cattiva',
      'Molto cattiva'
    ]
  },
  {
    position: 17, question: 'Nell\'ultimo mese, quanto spesso ha preso farmaci (prescritti dal medico o meno) ' +
      'aiutarsi a dormire?',
    answers: [
      'Non durante l\'ultimo mese',
      'Meno di una volta a settimana',
      'Una o due volte a settimana',
      'Tre o più volte a settimana'
    ]
  },
  {
    position: 18, question: 'Nell\'ultimo mese, quanto spesso ha avuto difficoltà a rimanere sveglia/o alla guida ' +
      'o nel corso di attività sociali?',
    answers: [
      'Non durante l\'ultimo mese',
      'Meno di una volta a settimana',
      'Una o due volte a settimana',
      'Tre o più volte a settimana'
    ]
  },
  {
    position: 19, question: 'Nell\'ultimo mese, ha avuto problemi ad avere energie sufficienti per concludere le sue ' +
      'normali attività?',
    answers: [
      'Per niente',
      'Poco',
      'Abbastanza',
      'Molto'
    ]
  }
];

/* ------------ RESULTS CONFIGURATION + CONSTRUCTOR ------------ */

export class PSQIResults {
  patientSSN: string;
  doctorID: string;
  results: string[];

  constructor(doctorID: string, patientSSN: string, results: string[]) {
    this.doctorID = doctorID;
    this.patientSSN = patientSSN;
    this.results = results;
  }

}
